const CertificateData = [
    {
        id:1,
        projectName:"Letter Of Recommendation",
        demo:"https://drive.google.com/file/d/1gGiACBe-pg89E3BbuWzOogrnXuELg8p0/view?usp=drive_link",
        imgsrc:"/Sabeena.jpg"
    },
    {
        id:2,
        projectName:"Industrial Training",
        demo:"https://drive.google.com/file/d/1_QnUDTUlwaogzLZW4pwCYsiQ6rLOi3l7/view?usp=drive_link",
        imgsrc:"/ThinkNext.jpg"
    },
    {
        id:3,
        projectName:"Data Structures & Algorithms",
        demo:"https://drive.google.com/file/d/1NpwuAYNe-C4lNwxKPDvp90o8Un0ohf8q/view?usp=drive_link",
        imgsrc:"/Udemy.jpg"
    },
    {
        id:4,
        projectName:"Web Development",
        demo:"https://drive.google.com/file/d/15Lg_T0o3yddqs2QgALkhna0MRStLIwde/view?usp=drive_link",
        imgsrc:"/Octanet.jpg"
    },
    {
        id:5,
        projectName:"Java Training",
        demo:"https://drive.google.com/file/d/1jhgxMQo6Dn7qTNPhu2uozsTAk30dhecp/view?usp=drive_link",
        imgsrc:"/RITESH-THAKUR-Participant-Certificate-1.jpg"
    },
    {
        id:6,
        projectName:"Hackathon",
        demo:"https://drive.google.com/file/d/1vMsDiEoZgeyjmvxAOUaNPp6jhAk6GTag/view?usp=drive_link",
        imgsrc:"/Hackathon.jpg"
    },
    {
        id:7,
        projectName:"Full Stack Development",
        demo:"https://drive.google.com/file/d/11QSigHPlmLLIX1BxkwyrFvSLxhAR6o7b/view?usp=drive_link",
        imgsrc:"/BharatIntern.jpg"
    },
    {
        id:8,
        projectName:"Full Stack Development",
        demo:"https://drive.google.com/file/d/1ntmppmtHYcXfHoLYtK3TtymupX1evUoo/view?usp=drive_link",
        imgsrc:"/30daysCoding.jpg"
    },
]

export default CertificateData;